import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import { MAX_INT } from '../../../utils/number';

var CountdownTimer = /*#__PURE__*/function (_Component) {
  _inherits(CountdownTimer, _Component);

  var _super = _createSuper(CountdownTimer);

  function CountdownTimer(props) {
    var _this;

    _classCallCheck(this, CountdownTimer);

    _this = _super.call(this, props);
    _this.state = {
      timerBackgroundColor: 'green'
    };
    var justTimerText = props.justTimerText;
    var millisecondsRemaining = Math.abs(props.endDate - new Date());

    if (millisecondsRemaining > MAX_INT || justTimerText) {
      return _possibleConstructorReturn(_this);
    }

    var dangerThreshold = props.timerBackgroundThresholds.danger;
    var warnThreshold = props.timerBackgroundThresholds.warn;

    var initializeDangerTimeout = function initializeDangerTimeout() {
      setTimeout(function () {
        _this.setState({
          timerBackgroundColor: 'red'
        });
      }, millisecondsRemaining - dangerThreshold);
    };

    var initializeWarningTimeout = function initializeWarningTimeout() {
      setTimeout(function () {
        _this.setState({
          timerBackgroundColor: 'yellow'
        });
      }, millisecondsRemaining - warnThreshold);
    };

    if (millisecondsRemaining < dangerThreshold) {
      _this.state.timerBackgroundColor = 'red';
    } else if (millisecondsRemaining < warnThreshold) {
      _this.state.timerBackgroundColor = 'yellow';
      initializeDangerTimeout();
    } else {
      initializeDangerTimeout();
      initializeWarningTimeout();
    }

    return _this;
  }

  _createClass(CountdownTimer, [{
    key: "render",
    value: function render() {
      var justTimerText = this.props.justTimerText;
      return this.props.render({
        // Pass state and handlers to platform renderer
        timerBackgroundColor: this.state.timerBackgroundColor,
        justTimerText: justTimerText
      });
    }
  }]);

  return CountdownTimer;
}(Component);

export { CountdownTimer as default };
CountdownTimer.defaultProps = {
  timerBackgroundThresholds: {
    warn: 12 * 60 * 60 * 1000,
    // Half Day
    danger: 1 * 60 * 60 * 1000 // 1 Hour

  }
};